import { CircleAlert, Info, TriangleAlert, type LucideIcon } from 'lucide-react';
import { AlarmSeverity } from '@/types';
import { SEVERITY_SOFT_BG_CLASS, SEVERITY_TEXT_CLASS } from './severityStyles';

const ICON_BY_SEVERITY: Record<AlarmSeverity, LucideIcon> = {
  crit: CircleAlert,
  warn: TriangleAlert,
  info: Info,
};

export interface SeverityIconProps {
  severity: AlarmSeverity;
  size?: number;
}

/** The colored square icon badge on every alarm row. */
export function SeverityIcon({ severity, size = 30 }: SeverityIconProps) {
  const Icon = ICON_BY_SEVERITY[severity];

  return (
    <span
      className={`flex shrink-0 items-center justify-center rounded-lg ${SEVERITY_SOFT_BG_CLASS[severity]} ${SEVERITY_TEXT_CLASS[severity]}`}
      style={{ width: size, height: size }}
    >
      <Icon size={size * 0.55} strokeWidth={2} />
    </span>
  );
}
